import { AxiosInstance } from 'axios';

import { SERVICE_ORDER_URLS } from '@/constants/urls';
import { ServiceOrder } from '@/model/ServiceOrder/ServiceOrder';
import { ServiceOrderItem } from '@/model/ServiceOrder/ServiceOrderItem';
import { RESOURCES } from '@/Resources';

class ServiceOrderApi {
  axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getServiceOrderByTicket(ticketId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .get(RESOURCES.SERVICE_ORDERS, { params: { tickets: ticketId } })
        .then(response => {
          resolve(response.data);
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }

  saveServiceOrderItem(item: Partial<ServiceOrderItem>): Promise<ServiceOrderItem> {
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .post(`${SERVICE_ORDER_URLS.SERVICE_ORDER_ITEMS}`, item)
        .then(response => {
          resolve(response.data);
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }
  updateServiceOrderItem(item: Partial<ServiceOrderItem>): Promise<ServiceOrderItem> {
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .patch(`${SERVICE_ORDER_URLS.SERVICE_ORDER_ITEMS}/${item.id}`, item)
        .then(response => {
          resolve(response.data);
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }
  deleteServiceOrderItem(item: Partial<ServiceOrderItem>): Promise<ServiceOrderItem> {
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .delete(`${SERVICE_ORDER_URLS.SERVICE_ORDER_ITEMS}/${item.id}`)
        .then(response => {
          resolve(response.data);
        })
        .catch((error: any) => {
          reject(error?.response?.data?.detail);
        });
    });
  }

  async getServiceOrderItems(serviceOrderId: number) {
    try {
      const response = await this.axiosInstance.get(`${SERVICE_ORDER_URLS.SERVICE_ORDER_ITEMS}`, {
        params: {
          service_order: serviceOrderId,
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async updateServiceOrder(serviceOrder: Partial<ServiceOrder>): Promise<ServiceOrder> {
    try {
      const response = await this.axiosInstance.patch(
        `${RESOURCES.SERVICE_ORDERS}/${serviceOrder.id}`,
        serviceOrder,
      );

      return response.data;
    } catch (error: any) {
      console.error('Error updating service order:', error);
      throw error?.response?.data?.detail || error;
    }
  }

  /**
   * Sube la Nota Fiscal (bill_file) al endpoint dedicado vía multipart POST.
   * No se setea Content-Type: axios lo genera con el boundary correcto al detectar FormData.
   */
  async uploadBillFile(serviceOrderId: number, file: File): Promise<ServiceOrder> {
    const formData = new FormData();

    formData.append('file', file, file.name);
    const url = SERVICE_ORDER_URLS.UPLOAD_BILL_FILE.replace('{id}', String(serviceOrderId));
    const response = await this.axiosInstance.post(url, formData);

    return response.data;
  }

  async generatePublicLink(serviceOrderId: number): Promise<string> {
    const response = await this.axiosInstance.post(
      `${RESOURCES.SERVICE_ORDERS}/${serviceOrderId}/generate-public-link/`,
      {},
    );

    return response.data.url;
  }
}
export default ServiceOrderApi;
